// Voicemail Status
export enum VoicemailStatus {
  PENDING = 'PENDING',
  AUTOMATICALLY_RESOLVED = 'AUTOMATICALLY_RESOLVED',
  MANUALLY_RESOLVED = 'MANUALLY_RESOLVED',
}

// Voicemail Direction
export enum VoicemailDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

// Voicemail Status Display (kebab-case for frontend)
export const VOICEMAIL_STATUS_DISPLAY: Record<VoicemailStatus, string> = {
  [VoicemailStatus.PENDING]: 'pending',
  [VoicemailStatus.AUTOMATICALLY_RESOLVED]: 'auto-resolved',
  [VoicemailStatus.MANUALLY_RESOLVED]: 'resolved',
};

// Voicemail Status Colors
export const VOICEMAIL_STATUS_COLORS: Record<VoicemailStatus, string> = {
  [VoicemailStatus.PENDING]: '#FF7B00',
  [VoicemailStatus.AUTOMATICALLY_RESOLVED]: '#389FBA',
  [VoicemailStatus.MANUALLY_RESOLVED]: '#389FBA',
};

// Agent interface for assignee
export interface Agent {
  id: number;
  name: string | null;
  coreProviderId: number | null;
}

// Voicemail Log interface matching backend
export interface VoicemailLog {
  id: number;
  twilioCallSid: string;
  twilioRecordingSid: string;
  fromNumber: string;
  fromName?: string;
  toNumber: string;
  toName?: string;
  direction?: VoicemailDirection;
  duration: number; // seconds
  status: VoicemailStatus;
  notes?: string;
  coreMemberId?: number;
  coreProviderId?: number;
  assigneeId?: number | null;
  assignee?: Agent;
  recordingUrl?: string;
  transcriptionUrl?: string;
  callLogId?: number;
  createdAt: string;
  updatedAt: string;
}

// Enhanced voicemail with member/agent data
export interface EnrichedVoicemailLog extends VoicemailLog {
  from?: {
    name: string;
    phoneNumber: string;
    id?: string;
    location?: string;
  };
  to?: {
    name: string;
    phoneNumber: string;
    id?: string;
    location?: string;
  };
}

// Query parameters for voicemail search
export interface FindAllVoicemailsParams {
  status?: VoicemailStatus[];
  coreMemberId?: number;
  coreProviderId?: number;
  assigneeId?: number;
  from?: string;
  to?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
  // Clinic filter (server clamps to the caller's permitted clinics).
  clinicIds?: number[];
  includeUnassigned?: boolean;
}

// Update voicemail params
export interface UpdateVoicemailParams {
  status?: VoicemailStatus;
  notes?: string;
  assigneeId?: number;
}
